import React from 'react';

import FormatNumbers from '../../../../utils/formatNumbers';
import { Button} from 'reactstrap';


export const FooterQuoterMic = (props) => {

    const {
        optionsTotal, total_tax, viewQuoter,
        formQuoterMic, handleChangeTypeClient, setActiveIndex,
        setHideTabs, hasDeterminations, handleViewQuoter, handleClosedQuoter,
        totalSample, totalDeterminations
    
    } = props;
    

    return (

        <div className="quoter-footer-dynamic d-none d-md-flex">
            <div className="footer-title">
                <span>RESUMEN DE</span>
                <span>COTIZACIÓN</span>
            </div>

            <div className="footer-summary-badges">

                <div className="footer-stat-card">
                    <div className="footer-stat-icon sample">
                        <i className="fa fa-flask"></i>
                    </div>

                    <div className="footer-stat-content">
                        <strong>{totalSample}</strong>
                        <span>Muestras</span>
                    </div>
                </div>

                <div className="footer-stat-card">
                    <div className="footer-stat-icon determination">
                        <i className="fa fa-flask"></i>
                    </div>

                    <div className="footer-stat-content">
                        <strong>{totalDeterminations}</strong>
                        <span>Determinaciones</span>
                    </div>
                </div>

            </div>

            <div className="footer-divider"></div>
            <div className="footer-metrics">

                <div className="footer-chip-quoter-mic ">
                    <span>SUBTOTAL</span>
                    <strong>
                        ${Number(optionsTotal?.subtotal || 0).toFixed(2)}
                    </strong>
                </div>

                <div className="footer-chip-quoter-mic ">
                    <span>I.V.A({total_tax}%)</span>
                    <strong>
                        ${FormatNumbers(optionsTotal.tax, 2)}
                    </strong>
                </div>

                <div className="footer-chip-quoter-mic ">
                    <span>TOTAL</span>
                    <strong>
                        ${FormatNumbers(optionsTotal.total, 2)}
                    </strong>
                </div>

            </div>

            <div className="footer-actions">
                {
                    !viewQuoter &&
                    formQuoterMic.id_quatation !== null &&
                    formQuoterMic.valid_sampling &&

                    <button
                        className={`footer-ios-btn ${viewQuoter
                                ? "footer-ios-btn-secondary"
                                : "footer-ios-btn-preview"
                            } ${!hasDeterminations ? "footer-btn-disabled" : ""}`}
                        onClick={() => {
                            handleChangeTypeClient(4);
                            if (setActiveIndex) setActiveIndex(0);
                            if (setHideTabs) setHideTabs(false);
                        }}
                        disabled={!hasDeterminations}
                    >
                        {formQuoterMic.code_quatation
                            ? "Regresar al listado"
                            : "Nueva cotización"}
                    </button>
                }

                <Button
                    className={`footer-ios-btn footer-ios-btn-save ${!hasDeterminations ? "footer-btn-disabled" : ""}`}
                    onClick={viewQuoter ? handleClosedQuoter : handleViewQuoter}
                    disabled={!hasDeterminations}
                >
                    {viewQuoter ? "Cerrar Vista" : "Previsualizar cotización"}
                </Button>

            </div>
        </div>

    )
}
